<template>
  <div class="app_detail_container">
    <PageTitle
      :title="title"
      :showFileBtn="true"
      backPath="AppSporadic"
      :menuArgs="menuArgs"
      @clickFileBtn="clickFileBtn"
    />
    <div class="app_menu_main">
      <div
        v-if="
          String($store.state.userInfo.authority).includes('领导审核') ||
            String($store.state.userInfo.authority).includes('财务审核')
        "
      >
        <SporadicPrint ref="SporadicPrintRef" :printData="form" />
      </div>
      <div v-else>
        <PageDetailDivider ref="PageDetailDividerRef" title="主表信息" />
        <div class="app_menu_main_form">
          <el-form :rules="rules" :model="form">
            <el-form-item label="公司" prop="company">
              <el-input placeholder="关联获取" readonly v-model="form.company" />
            </el-form-item>
            <el-form-item label="报销日期" prop="r_date">
              <el-input placeholder="关联获取" v-date readonly v-model="form.r_date" />
            </el-form-item>
            <el-form-item label="报销人" prop="users_name">
              <el-input placeholder="关联获取" readonly v-model="form.users_name" />
            </el-form-item>
            <el-form-item label="粘贴单据(张)" prop="document_count">
              <el-input placeholder="关联获取" readonly v-model="form.document_count" />
            </el-form-item>
            <el-form-item label="金额" prop="amout">
              <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.amout" />
            </el-form-item>
            <el-form-item label="大写金额" prop="amout">
              <el-input placeholder="自动计算" readonly :value="convertCurrency(form.amout)" />
            </el-form-item>
            <el-form-item label="事由" prop="subject_matter">
              <el-input type="textarea" :rows="5" placeholder="关联获取" readonly v-model="form.subject_matter" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <PageDetailBtns ref="PageDetailBtnsRef" menuPath="Sporadic" :parentData="this" @handleClick="handleClickBtn" />
    <!-- 附件 -->
    <PageDetailFile ref="PageDetailFileRef" :ID="id" vuePath="Sporadic" />
    <!-- 财务审批 -->
    <FinancialReviewModalVue ref="FinancialReviewModalVueRef" @sureHandler="sureFinancialReview" />
    <!-- 确认dialog -->
    <ConfirmModal ref="ConfirmModalRef" @confirm="sureConfirm" />
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageDetailBtns from '@/components/app/PageDetailBtns.vue'
import PageDetailDivider from '@/components/app/PageDetailDivider.vue'
import PageDetailFile from '@/components/app/PageDetailFile.vue'
import FinancialReviewModalVue from '@/components/common/ReviewModal.vue'
import ConfirmModal from '@/components/app/ConfirmModal.vue'
import SporadicPrint from '@/components/print/Sporadic.vue'

export default {
  components: {
    PageTitle,
    PageDetailBtns,
    PageDetailDivider,
    PageDetailFile,
    FinancialReviewModalVue,
    ConfirmModal,
    SporadicPrint
  },
  data() {
    return {
      id: -1,
      title: '零星费用明细',
      formVisible: false,
      // 表单
      form: {
        id: '',
        document_status: '',
        manager_review: '',
        company: '',
        r_date: '',
        r_user_id: '',
        r_user: '',
        document_count: '',
        amout: '',
        subject_matter: ''
      },
      rules: {
        company: [],
        r_date: [],
        r_user: [],
        document_count: [],
        amout: [],
        subject_matter: []
      },
      // 下拉框
      ComBoxItems: {
        company: []
      },
      // 展示金额
      showMoney: true,
      menuArgs: ''
    }
  },
  mounted() {
    this.id = this.$route.query.id

    this.BindText()

    this.menuArgs = this.$route.query.menuArgs
  },
  methods: {
    // 确认
    async sureConfirm(code) {
      if (code === 'refuse') {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'leaderReview') {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'unReview') {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'financialReview') {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功')

          this.$emit('updateData')
          this.BindText()
        }
      }
    },
    // 拒绝
    refuse() {
      this.$refs.ConfirmModalRef.openDialog('refuse')
    },
    // 领导/总经理审批
    leaderReview() {
      this.$refs.ConfirmModalRef.openDialog('leaderReview')
    },
    // 财务审核通过
    async sureFinancialReview(flag) {
      const success = await this.sureReview(flag)
      if (success) {
        this.$message.success('操作成功')
        this.$refs.FinancialReviewModalVueRef.formVisible = false

        this.$emit('updateData')
        this.BindText()
      }
    },
    // 取消审核
    unReview() {
      this.$refs.ConfirmModalRef.openDialog('unReview')
    },
    // 调用审批接口
    async sureReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/petty_expense_reimbursement_form/audit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/petty_expense_reimbursement_form/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/finance/petty_expense_reimbursement_form/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'financialReview':
          // this.$refs.FinancialReviewModalVueRef.formVisible = true

          this.$refs.ConfirmModalRef.openDialog('financialReview')
          break
        case 'unReview':
          this.unReview()
          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
      }
    },
    // 绑定数据
    async BindText() {
      const that = this
      const { data: res } = await that.$http.get('/finance/petty_expense_reimbursement_form', {
        params: {
          id: that.id
        }
      })
      if (res.isSuccess) {
        that.form = res.data
      }

      this.$nextTick(() => {
        if (this.$refs.SporadicPrintRef) {
          this.$refs.SporadicPrintRef.handlePrint()
        }
      })
    },
    // 点击附件按钮
    clickFileBtn() {
      this.$refs.PageDetailFileRef.openDialog()
    },
    showModal() {},
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    // 选择人员
    handleSelect() {},
    // 主表选择框值改变为空时
    clearFormToNull(type) {
      switch (type) {
        case '':
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

.app_detail_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    // background-color: #fafafa;

    overflow: auto;

    box-sizing: border-box;
    // padding: 0 20px;
    // padding-top: 10px;
    // padding-bottom: 20px;

    /deep/ .el-form-item__label {
      padding: 0 !important;
      font-size: 20px !important;
      font-weight: 500;
      color: #a78897;
    }
    /deep/ .el-input__inner {
      border: 0 !important;
      border-bottom: 1px solid #d1d1d1 !important;
      border-radius: 0;
      padding-left: 0 !important;
      transition: all 0.3s;
      // background-color: #fafafa;
      font-size: 18px !important;
    }

    /deep/ .el-textarea__inner {
      font-size: 18px !important;
    }

    // /deep/ .el-input__inner:hover {
    //   padding-left: 10px !important;
    //   transition: all 0.3s;
    // }
    /deep/ .el-input__inner:focus {
      padding-left: 10px !important;
      transition: all 0.3s;
    }

    .app_menu_main_form {
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
    }
  }
}
.file-list-container {
  // box-sizing: border-box;
  padding: 10px;

  height: 30px;
}
</style>
